import { render, staticRenderFns } from "./SyncTranslations.vue?vue&type=template&id=21d38d94&lang=pug"
import script from "./SyncTranslations.vue?vue&type=script&lang=js"
export * from "./SyncTranslations.vue?vue&type=script&lang=js"
import style0 from "./SyncTranslations.vue?vue&type=style&index=0&id=21d38d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports